<template>
  <div>
    <button type="button" class="btn btn-primary btn-block" @click="isOpen = !isOpen">
      Mail versturen naar iedereen
    </button>

    <div v-if="isOpen" class="modal d-block" role="dialog">
      <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Mail versturen naar iedereen</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
              @click="close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <p>
              Het is niet mogelijk om meerdere soorten e-mail te gelijk te
              bekijken.
            </p>

            <NoteForm v-model="note" />

            <hr />

            <p>Deze mail wordt verzonden naar: {{ mails }}</p>
          </div>

          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-primary"
              @click="send"
              :disabled="isLoading"
            >
              Versturen
            </button>
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
              @click="close"
            >
              Annuleren
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NoteForm from "./NoteForm.vue";

export default {
  components: { NoteForm },
  name: "CancellationModal",
  props: {
    booking: {
      type: Object,
    },
    isCancelled: {
      type: Boolean,
    },
    mails: {
      type: String,
    },
  },
  data() {
    return {
      isOpen: false,
      note: "",
      isLoading: false,
    };
  },
  methods: {
    close() {
      this.isOpen = false;
      this.isLoading = false;
    },
    async send() {
      this.isLoading = true;
      let url = `/admin/bookings/mail?recipient=all&booking=${this.booking.id}`;

      if (!!this.note) {
        url += `&note=${this.note}`;
      }

      await axios.post(url);
      this.close();
    },
  },
  watch: {
    isOpen(isOpen) {
      this.note = "";

      if (isOpen) {
        document.body.classList.add("modal-open");
      } else {
        document.body.classList.remove("modal-open");
      }
    },
  },
};
</script>